export default {
  baseApiUrl: process.env.VUE_APP_BASE_API_URL,
  baseStakeApiUrl: process.env.VUE_APP_BASE_STAKE_API_URL,
  wsUrl: process.env.VUE_APP_WS_URL,
  recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  requestHeaders: {
    authToken: process.env.VUE_APP_REQUEST_HEADERS_AUTH_TOKEN,
    resetPasswordToken:
      process.env.VUE_APP_REQUEST_HEADERS_RESET_PASSWORD_TOKEN,
    refreshToken: process.env.VUE_APP_REQUEST_HEADERS_REFRESH_TOKEN,
  },
  fortmatic: {
    apiKey: process.env.VUE_APP_FORTMATIC_API_KEY,
    network: process.env.VUE_APP_FORTMATIC_NETWORK,
  },
  torus: {
    network: {
      host: process.env.VUE_APP_TORUS_NETWORK_HOST,
    },
  },
  ethNetworkChainId: process.env.VUE_APP_ETH_NETWORK_CHAIN_ID,
  etherscanApiKey: process.env.VUE_APP_ETHERSCAN_API_KEY,
  googleClientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
  facebookAppId: process.env.VUE_APP_FACEBOOK_APP_ID,
  infuraId: process.env.VUE_APP_INFURA_ID,
  infuraEndpoints: process.env.VUE_APP_INFURA_ENDPOINTS_PREFIX,
  walletConnectBridge: process.env.VUE_APP_WALLET_CONNECT_BRIDGE,
  gnosis: {
    mastercopyAddress: process.env.VUE_APP_GNOSIS_MASTERCOPY_ADDRESS,
    proxyFactoryAddress: process.env.VUE_APP_GNOSIS_PROXY_FACTORY_ADDRESS,
  },
  walletconnect: {
    projectId: process.env.VUE_APP_WALLETCONNECT_PROJECT_ID,
  },
};
